import { MASQUERADE_BANNER_HEIGHT_PX } from "components/MasqueradeBanner";
import { useAppUpdate } from "hooks/useAppUpdate";
import { tokenManager } from "lib/tokenManager";

/**
 * PRTL-1360: persistent full-width bar shown when a deploy has happened
 * since this tab loaded. Assets are content-hashed and index.html is served
 * no-cache, so a reload deterministically picks up the new bundle.
 *
 * Sits below the masquerade banner when both are showing — both are
 * `fixed top-0 z-[100]`, so without the offset they render exactly on top of
 * each other and one is invisible.
 */
export const UpdateBanner = () => {
    const { updateAvailable } = useAppUpdate();
    const isMasquerading = tokenManager.isMasquerading();

    if (!updateAvailable) return null;

    return (
        <div
            className="fixed inset-x-0 z-[100] flex items-center justify-center gap-3 border-b border-sky-300 bg-sky-100 px-4 py-2 text-sm text-sky-900"
            style={{ top: isMasquerading ? MASQUERADE_BANNER_HEIGHT_PX : 0 }}
        >
            <span className="font-medium">A new version of Navigator is available.</span>
            <button
                onClick={() => window.location.reload()}
                className="rounded-md border border-sky-400 bg-white px-2.5 py-1 text-xs font-semibold text-sky-900 hover:bg-sky-50"
            >
                Reload
            </button>
        </div>
    );
};
